;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { NotificationPreference } from "@/prisma/generated/client";
import type { Organization } from "@/types/organization";
import type { Permission } from "@/types/permissions";
import type { Workspace, WorkspaceUserStatus } from "@/types/workspace";

export enum UserRole {
	ADMIN = "ADMIN",
	USER = "USER",
}

export interface UserData {
	id: string;
	firstName: string;
	lastName: string;
	email: string;
	role: UserRole;
	phone: string;
	profilePicture?: string | null;
	createdAt: string;
	orgPermissions: Permission[];
	/** Engineering support admin — hidden from member lists; unlocks support tooling. */
	isSupportUser?: boolean;
}

export interface UserDataResponse {
	user: UserData;
	organization: Organization;
	organizationPermissions: Permission[];
	workspaces: Workspace[];
}

export interface InvitedUser {
	id: string;
	email: string;
	role: UserRole;
	permissions: {
		[key: string]: {
			view: boolean;
			create: boolean;
			edit: boolean;
			delete: boolean;
		};
	};
}

export interface WorkspaceMember {
	id: string;
	role: UserRole;
	createdAt: string;
	updatedAt: string;
	status: WorkspaceUserStatus;
	user: {
		firstName: string;
		lastName: string;
		email: string;
		role: UserRole;
		isSupportUser?: boolean;
		profilePicture?: string | null;
	};
	permissions: {
		id: string;
		resource: string;
		canView: boolean;
		canCreate: boolean;
		canEdit: boolean;
		canDelete: boolean;
	}[];
	userId: string;
	workspaceId: string;
}

export interface UserSettingsResponse {
	notificationSetting?: {
		preferences: NotificationPreference[];
		userId: string;
		updatedAt: string;
		createdAt: string;
		id: string;
	};
}
